import { render, staticRenderFns } from "./ztGoodsDetails.vue?vue&type=template&id=6b1b7011&scoped=true&"
import script from "./ztGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./ztGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ztGoodsDetails.vue?vue&type=style&index=0&id=6b1b7011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b7011",
  null
  
)

export default component.exports